import { memo } from "react";
import { Link } from "react-router-dom";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";

import ServiceConnectionStep from "components/ServiceConnectionStep";

// -----------------------------------------------------------------------------

const CompletedPhase = memo(function CompletedPhase({
  disabled,
  successIcon,
  onClickFn,
}: CompletedPhaseProps): JSX.Element {
  return (
    <ServiceConnectionStep disabled={disabled}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {successIcon ? (
          <CheckCircleOutlineRoundedIcon color="success" sx={{ mr: 1 }} />
        ) : null}
        <Typography variant="body1">Done!</Typography>
      </Box>
      <Stack sx={{ mt: 2 }} spacing={1} direction="column">
        <Typography variant="body1">
          <Link to="/environment/sources" onClick={() => onClickFn()}>
            Click here
          </Link>{" "}
          to return to your sources. You will be redirected in a few seconds.
        </Typography>
      </Stack>
    </ServiceConnectionStep>
  );
});

export default CompletedPhase;

// -----------------------------------------------------------------------------

interface CompletedPhaseProps {
  disabled: boolean;
  successIcon: boolean;
  onClickFn: Function;
}
